import React, { MouseEvent, useEffect, useState } from 'react';

import MenuList, { IMenuList, IMenuListLink } from '../../molecules/menu-list/menu-list';

const findSelectedItemIndex = (links: IMenuListLink[]) =>
  (links.findIndex((link: IMenuListLink) => link.isSelected) && !-1) || 0;

interface IDropdownMenu extends IMenuList {
  analyticsDataAttribute?: string;
}

const DropdownMenu = ({
  /* istanbul ignore next: default value on mandatory field */ links = [],
  /* istanbul ignore next: default value on mandatory field */ onClick = () => {},
  /* istanbul ignore next: default value on mandatory field */ showSelected = false,
  /* istanbul ignore next: default value on mandatory field */ menuSize,
  /* istanbul ignore next: default value on mandatory field */ variant = 'DROPDOWN',
  title,
  text,
  analyticsDataAttribute,
}: IDropdownMenu) => {
  const [menuText, setMenuText] = useState(text);
  const [selectedElementIndex, setSelectedElementIndex] = useState(findSelectedItemIndex(links));

  /** To sync prop text with menuText state */
  useEffect(() => {
    setMenuText(text);
  }, [text]);

  const onMenuItemSelected = (event: MouseEvent, selectedIndex: number) => {
    /* istanbul ignore else */ if (links[selectedElementIndex]) {
      links[selectedElementIndex].isSelected = false;
    }

    const elementSelected: IMenuListLink = links[selectedIndex];
    elementSelected.isSelected = true;

    setSelectedElementIndex(selectedIndex);
    setMenuText(elementSelected.label);
    onClick(event, selectedIndex);
  };

  return (
    <MenuList
      links={links}
      title={title}
      text={menuText}
      onClick={onMenuItemSelected}
      showSelected
      menuSize={menuSize}
      variant={variant}
      analyticsDataAttribute={analyticsDataAttribute}
    />
  );
};

export default DropdownMenu;
